import { render, staticRenderFns } from "./costServingIndex.vue?vue&type=template&id=08dad79a&"
import script from "./costServingIndex.vue?vue&type=script&lang=js&"
export * from "./costServingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports